import { useLocalization } from '@fluent/react';
import { useNavigate } from 'react-router-dom';

import appleLogo from '#/assets/static-page/apple_logo.svg';
import facebookLogo from '#/assets/static-page/facebook_logo.svg';
import instagramLogo from '#/assets/static-page/instagram_logo.svg';
import moveLogo from '#/assets/static-page/move_logo.png';
import playstoreLogo from '#/assets/static-page/google_playstore_logo.svg';
import { PublicRoute } from '#/constants/page-route';

const SiteMapFooter = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full px-10 pt-8 bg-gradient-to-tl from-[#d7f5f1] via-blue-500 to-[#000c69]">
      <div className="flex justify-between pb-5">
        <div className="flex text-white gap-x-8">
          <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.AboutUs)}>
            {l10n.getString('about-us')}
          </div>
          <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.ContactUs)}>
            {l10n.getString('contact-us')}
          </div>
          {/* <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.Faq)}>
            Help & FAQs
          </div> */}
        </div>
        <div className="flex justify-end w-2/4 gap-16">
          {/* <div className="flex items-center gap-x-5">
            <div className="px-5 text-white">DOWNLOAD</div>
            <div className="flex gap-x-8">
              <img src={appleLogo} className="w-6" />
              <img src={playstoreLogo} className="w-6" />
            </div>
          </div> */}
          {/* <div className="flex items-center gap-x-5">
            <div className="px-5 text-white uppercase">{l10n.getString('follow-us')}</div>
            <div className="flex gap-x-8">
              <img src={instagramLogo} className="w-5" />
              <img src={facebookLogo} className="w-3" />
            </div>
          </div> */}
        </div>
      </div>
      <div className="flex justify-between pt-5 border-t">
        <div className="flex text-white gap-x-8">
          <div
            className="hover:cursor-pointer"
            onClick={() => navigate(PublicRoute.TermsOfService)}
          >
            {l10n.getString('terms-of-service')}
          </div>
          <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.PrivacyPolicy)}>
            {l10n.getString('privacy-policy')}
          </div>
        </div>
        <div className="self-end text-sm text-white">
          &copy; {new Date().getFullYear()} Daily Move Sdn. Bhd.
        </div>
      </div>
      <div className="py-10 pt-12">
        <img src={moveLogo} />
      </div>
    </div>
  );
};

export default SiteMapFooter;
